import React from "react";
import LegalShell, { Section } from "@/components/LegalShell";

export default function Terms() {
  return (
    <div data-testid="terms-page">
      <LegalShell eyebrow="Trust" title="Terms of Use" updated="7 February 2026">
        <Section title="Welcome to WR Rishtey">
          <p>
            By creating an account or using any part of the WR Rishtey
            website (the "Service"), you accept the terms below. Please read
            them carefully — they exist to protect both you and every other
            family who trusts us with their matchmaking journey.
          </p>
        </Section>

        <Section title="1. Eligibility">
          <p>You must be at least 18 years old and legally free to marry
            under the laws of the country in which you reside. Profiles must
            represent a real person and must be created by that person or with
            their explicit consent (e.g. a parent or wali).</p>
        </Section>

        <Section title="2. Honest representation">
          <ul className="list-disc pl-5 space-y-2">
            <li>All information in your dossier must be truthful.</li>
            <li>Marital status, education, and career details will be verified before your profile becomes visible.</li>
            <li>Impersonation, misrepresentation, or fraudulent activity results in immediate account termination without refund.</li>
          </ul>
        </Section>

        <Section title="3. Membership & payments">
          <ul className="list-disc pl-5 space-y-2">
            <li>Registration is free. Paid tiers (Silver / Gold / Platinum) unlock additional features and are billed monthly.</li>
            <li>Payments are processed by Razorpay or via manual UPI verification. Card details are never stored on our servers.</li>
            <li>Cancellations take effect at the end of the current billing month. Refunds are considered case-by-case per our fair-use policy — see our <a className="text-brand-terracotta underline underline-offset-4" href="/refund">Refund Policy</a>.</li>
          </ul>
        </Section>

        <Section title="4. Acceptable use">
          <p>You agree not to:</p>
          <ul className="list-disc pl-5 space-y-2">
            <li>Send unsolicited, indecent, or harassing messages.</li>
            <li>Solicit money, gifts, or investments from other members.</li>
            <li>Scrape, copy, or redistribute member data.</li>
            <li>Create profiles for anyone under 18 or without their consent.</li>
          </ul>
        </Section>

        <Section title="5. Content & introductions">
          <p>
            WR Rishtey offers introductions — not guaranteed outcomes. We do
            our best to verify every profile, but families are responsible for
            their own due-diligence before any Nikah is contracted.
          </p>
        </Section>

        <Section title="6. Termination">
          <p>We may suspend or terminate your account for violation of these
            terms, misuse of the platform, or on request of law enforcement.
            You may close your own account at any time from your profile
            settings.</p>
        </Section>

        <Section title="7. Governing law">
          <p>These terms are governed by the laws of India. Disputes shall be
            resolved through the courts of Mumbai, unless mandatory local
            consumer-protection law provides otherwise.</p>
        </Section>

        <Section title="8. Changes">
          <p>We may update these terms; the "Last updated" date above will
            change accordingly. Continued use of the Service after an update
            constitutes acceptance.</p>
        </Section>
      </LegalShell>
    </div>
  );
}
